module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAOFJREFUSEvtVNsNwjAMtMsqLEWR+8MUqEJVVSGm4KcRZSlmqVGJolSQh5OqHyDyG+fOvjsHmXkDKx78E8TU/WGJ+n54IMKVqLyEZFBqODLDoarKravOK5F+yB0iNET7s+uxUveaeWwR8eRrJOiBUreaGVoXiQUvGqKds4GpqajJLhIpuIhgKpqTABSgZQl3biSNTmAKDcmrKyG4eAI9hTZUE/iNfw+DaIK55gAj+IxPiqmVxkTRah5KV9IEFujTUCnJwkUze5KxaKt/FbFvWHovSpEULCtFS8CTFi2X6PslegL9NN4ZrqYNjgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_off.png
// module id = MZIe
// module chunks = 1